import thunkMiddleware from 'redux-thunk';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { createBrowserHistory, History } from 'history';
import { composeWithDevTools } from 'redux-devtools-extension';
import {
  connectRouter,
  routerMiddleware,
  RouterState,
} from 'connected-react-router';

import { catalogueReducer } from './catalogue/reducers';
import { CatalogueState } from './catalogue/types';

import { iconsReducer } from './icons/reducers';
import { IconsState } from './icons/types';

import { searchReducer } from './search/reducers';
import { SearchState } from './search/types';

import { sizesReducer } from './sizes/reducers';
import { SizesState } from './sizes/types';

import { statsReducer } from './stats/reducers';
import { StatsState } from './stats/types';

export const history = createBrowserHistory();

const rootReducer = (history: History) =>
  combineReducers({
    catalogue: catalogueReducer,
    icons: iconsReducer,
    search: searchReducer,
    sizes: sizesReducer,
    stats: statsReducer,
    router: connectRouter(history),
  });

export interface AppState {
  catalogue: CatalogueState;
  icons: IconsState;
  search: SearchState;
  sizes: SizesState;
  stats: StatsState;
  router: RouterState;
}

export default function configureStore(preloadedState?: any) {
  const middlewares = [thunkMiddleware];
  const middleWareEnhancer = applyMiddleware(
    routerMiddleware(history),
    ...middlewares
  );

  const store = createStore(
    rootReducer(history),
    preloadedState,
    composeWithDevTools(middleWareEnhancer)
  );

  return store;
}
